import { MaintenancePage } from 'components/maintenance/maintenancePage/MaintenancePage'
import { GetStaticProps } from 'next'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page() {
  return <MaintenancePage />
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return { props: { ...(await getIntlProps(ctx)) } }
}
